module.exports = __webpack_public_path__ + "static/media/Aspira-DEMO-webfont.494e82bb.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Aspira-DEMO-webfont.woff
// module id = 100
// module chunks = 13